import(/* webpackMode: "eager" */ "/ui/src/components/google-publisher-tags/gpt-header/index.js");
import(/* webpackMode: "eager" */ "/ui/node_modules/next/dist/client/script.js")